import React, { lazy } from "react";
import ReactDOM from "react-dom/client";

// ** Redux Imports
import { Provider } from "react-redux";
import { store } from "./redux/store";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./assets/scss/base/pages/index.scss";
import "./assets/scss/base/pages/global.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
